import useScheduleAppointment from "./schedule-followup-appointment";

const useScheduleRequestedAppointment = useScheduleAppointment;

export default useScheduleRequestedAppointment;
